import { render } from "./SpinLoader.vue?vue&type=template&id=3bea80bc&scoped=true"
const script = {}

import "./SpinLoader.vue?vue&type=style&index=0&id=3bea80bc&scoped=true&lang=css"

import exportComponent from "D:\\vue\\rs459\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bea80bc"]])

export default __exports__